// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2undt","alert":"SettungsInbox_alert__2DP-D"};